module.exports = __webpack_public_path__ + "img/main-section-2-2.d6390b62.png";